// マイページ開設・個人情報取扱等同意確認
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowserBack } from '../../BrowserBack';
import { clauses_list, clause_type } from '../../Const';
import AgreementTemplate from '../../molecules/AgreementTemplate';
import Popup from '../../molecules/Popup';
import TransitionButton from '../../molecules/TransitionButton';
import LoadingModal from '../../molecules/LoadingModal';
import { KWANKGM00140A01 } from '../../const/api_modules';

interface Clauses {
  heading: string;
  types: number[];
  main_btn_label: string;
  sub_btn_label: string;
  leave_text: string;
  sub_btn_area: JSX.Element | undefined;
}

const AgreementSolidarity = () => {
  // URLパラメータ取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const jacode = url_params.get('jacode');
  const reception_id = url_params.get('r_id');
  const reception_cd = url_params.get('r_cd');
  const guarantor_sub_no = url_params.get('guarantor_sub_no');
  // 画面構成
  const [clauses, setClauses] = useState<Clauses>(clauses_list[1]);
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(true);
  // 同意文の件名、本文のstate
  const [agreement_text, setAgreementText] = useState([]);
  // ポップアップ表示・非表示
  const [show_popup1, setShowPopup1] = useState(false);
  const [show_popup2, setShowPopup2] = useState(false);
  const [is_agreement_status_disagreement, SetAgreementStatusDisagreement] = useState(true);

  const [popup_button1, setPopupButton1] = useState({
    label: '通知する',
    variant: 'danger',
    handleClick: () => {
      setIsLoading(true);
      requestApi()
        .then(res => {
          togglePopup1();
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
  });
  const [popup_button2, setPopupButton2] = useState({
    label: '戻る',
    variant: 'white',
    handleClick: () => togglePopup2(),
  });

  const [popup_button3, setPopupButton3] = useState({
    label: '閉じる',
    variant: 'white',
    handleClick: () => togglePopup3(),
  });

  // CommonApiをキックする
  const requestApi = async () => {
    try {
      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWANKGM00140A01,
        is_json : true,
        reception_cd : reception_cd,
        reception_id : reception_id,
        detail : []
      });

      if (response.data.result) {
        SetAgreementStatusDisagreement(true);
      } else {
        SetAgreementStatusDisagreement(false);
      }

      return response;
    } catch (error) {
      SetAgreementStatusDisagreement(false);
      alert('システムエラーが発生しました');
      throw error;
    }
  };

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    fetchLists();
    getAgreementStatusDisagreement();
  }, []);

  // 案件に紐づく連帯保証人が不同意したかの情報を取得する
  const getAgreementStatusDisagreement = async () => {
    try {
      const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/agreement_status_disagreement`, {
        params: {
          reception_id: reception_id,
          guarantor_sub_no: guarantor_sub_no,
        },
      });

      if(response.data.result && typeof response.data.is_agreement_status_disagreement !== 'undefined'){
        SetAgreementStatusDisagreement(response.data.is_agreement_status_disagreement)
      }else{
        SetAgreementStatusDisagreement(false);
        console.error(response.data.message);
        alert(response.data.message);
      }

    } catch (error) {
      SetAgreementStatusDisagreement(false);
      console.error(error);
      alert('システムエラーが発生しました');
    }
  };

  // 同意文の取得
  const fetchLists = async () => {
    try {
      const response = await axios.get(`${location.origin}${process.env.MIX_MOCK_URL}/get_agreement_solidarity`, {
        params: {
          clause_types: clauses.types,
          ja_code: jacode,
        },
      });

      if (response.data.result) {
        setAgreementText(response.data.clauses);
        setClauses({
          ...clauses,
          sub_btn_area: (
            <TransitionButton
              label={clauses.sub_btn_label}
              btn_class={'btn-not_agree'}
              handleClick={() => setShowPopup1(true)}
            />
          ),
        });
      } else {
        console.error(response.data.message);
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  };

  // 画面下部中央のボタンを押下した時
  const mainButtonClick = async () => {
    try {
      setIsLoading(true);
      // 同意文ID格納用変数
      let mypage_clauses_id_list: string[] = [];
      let personal_clauses_id_list: string[] = [];

      // 同意文IDのリストを作成
      agreement_text.filter(value =>
        value['type'] === clause_type.mypage
          ? mypage_clauses_id_list.push(value['id'])
          : personal_clauses_id_list.push(value['id'])
      );

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/register_solidarity`, {
        ja_code: jacode,
        mypage_clauses_id_list: mypage_clauses_id_list,
        personal_clauses_id_list: personal_clauses_id_list,
      });

      // 画面遷移
      location.replace(response.data);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      alert('システムエラーが発生しました');
    }
  };

  // ポップアップの開閉
  const togglePopup1 = () => {
    setShowPopup1(false);
    setShowPopup2(true);
  };

  const togglePopup2 = () => {
    setShowPopup1(false);
  };

  const togglePopup3 = () => {
    setShowPopup2(false);
  };

  return (
    <>
      <AgreementTemplate
        agreement_text={agreement_text}
        clauses={clauses}
        main_btn_func={() => mainButtonClick()}
        is_disagreement={is_agreement_status_disagreement}
      />
      <Popup
        title="不承認通知"
        text="同意内容に同意いただけなかった旨、申込人に通知いたします。よろしいですか？"
        toggleShow={show_popup1}
        toggleClose={() => togglePopup2()}
        first_button={popup_button1}
        second_button={popup_button2}
      />
      <Popup
        title="不承認通知完了"
        text="各同意内容に同意いただけなかった旨を申込人に通知しました。ブラウザのウィンドウまたはタブを閉じて終了して下さい。"
        toggleShow={show_popup2}
        toggleClose={() => togglePopup3()}
        first_button={popup_button3}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('agreement-solidarity')) {
  render(<AgreementSolidarity />, document.getElementById('agreement-solidarity'));
}
